import './SideBar.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { logOut } from '../../utilities/services/users';
import { NavLink } from 'react-router-dom';

export default function SideBar({user, updateUser, isSideBarExpanded, setIsSideBarExpanded, isMobile}) {
    
    function handleLogOut(){
        logOut()
        updateUser(null)
        // navigate('/')
    }

  return (
    <div className={`SideBar ${(!isSideBarExpanded || isMobile) ? 'collapsed':''}`}>
        <div className={`topSection ${(!isSideBarExpanded || isMobile) ? 'collapsed':''}`} onClick={() => setIsSideBarExpanded(!isSideBarExpanded)}>
            <div className='headerImage'>
                <img src="https://project-intake-assets.s3.ca-central-1.amazonaws.com/Logo.svg" alt="Not Found"/>
            </div>
            <div className={`collapseSideBarContainer ${(!isSideBarExpanded || isMobile) ? 'collapsed':''}`}>
                <svg width="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.75" y="0.75" width="17.5" height="17.5" rx="3.25" stroke="#1B2B41" strokeOpacity="0.69" strokeWidth="1.5"/>
                    <rect x="4" y="4" width="3" height="12" rx="1.5" fill="#1B2B41" fillOpacity="0.69"/>
                </svg>
            </div>
        </div>
        <div className={`middleSection ${(!isSideBarExpanded || isMobile) ? 'collapsed':''}`}>
            <div className='navLinks'>
                { ['admin', 'manager', 'analyst'].includes(user.userType) &&
                <NavLink to='/' className='navLink'>
                    <button id='summary'>
                        <svg width="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" opacity="0.8">
                            <path d="M2.625 7.875L10.5 1.75L18.375 7.875V17.5C18.375 17.9641 18.1906 18.4092 17.8624 18.7374C17.5342 19.0656 17.0891 19.25 16.625 19.25H4.375C3.91087 19.25 3.46575 19.0656 3.13756 18.7374C2.80937 18.4092 2.625 17.9641 2.625 17.5V7.875Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M7.875 19.25V10.5H13.125V19.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        { (isSideBarExpanded && !isMobile) &&
                        <span className='buttonText'>
                            Home
                        </span>
                        }
                    </button>
                </NavLink>
                }
                { ['admin', 'manager'].includes(user.userType) &&
                <NavLink to='/leads' className='navLink'>
                    <button id='leads'>
                        <svg width="21" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                        </svg>
                        { (isSideBarExpanded && !isMobile) &&
                        <span className='buttonText'>
                            Leads
                        </span>
                        }
                    </button>
                </NavLink>
                }
                { ['admin', 'manager'].includes(user.userType) &&
                <NavLink to='/clients' className='navLink'>
                    <button id='clients'>
                        <svg width="21" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M18.3332 19.25V17.4167C18.3332 16.4442 17.9469 15.5116 17.2592 14.8239C16.5716 14.1363 15.639 13.75 14.6665 13.75H7.33317C6.36071 13.75 5.42808 14.1363 4.74045 14.8239C4.05281 15.5116 3.6665 16.4442 3.6665 17.4167V19.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M11.0002 10.0833C13.0252 10.0833 14.6668 8.44171 14.6668 6.41667C14.6668 4.39162 13.0252 2.75 11.0002 2.75C8.97512 2.75 7.3335 4.39162 7.3335 6.41667C7.3335 8.44171 8.97512 10.0833 11.0002 10.0833Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        { (isSideBarExpanded && !isMobile) &&
                        <span className='buttonText'>
                            Clients
                        </span>
                        }
                    </button>
                </NavLink>
                }
                { ['admin', 'manager'].includes(user.userType) &&
                <NavLink to='/forms' className='navLink'>
                    <button id='forms'>
                        <svg width="21" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M11.6668 1.66663H5.00016C4.55814 1.66663 4.13421 1.84222 3.82165 2.15478C3.50909 2.46734 3.3335 2.89127 3.3335 3.33329V16.6666C3.3335 17.1087 3.50909 17.5326 3.82165 17.8451C4.13421 18.1577 4.55814 18.3333 5.00016 18.3333H15.0002C15.4422 18.3333 15.8661 18.1577 16.1787 17.8451C16.4912 17.5326 16.6668 17.1087 16.6668 16.6666V6.66663L11.6668 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M11.6665 1.66663V6.66663H16.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13.3332 10.8334H6.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13.3332 14.1666H6.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.33317 7.5H7.49984H6.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        { (isSideBarExpanded && !isMobile) &&
                        <span className='buttonText'>
                            Forms
                        </span>
                        }
                    </button>
                </NavLink>
                }
                { ['admin', 'manager', 'analyst'].includes(user.userType) &&
                <NavLink to='/projects' className='navLink'>
                    <button id='projects'>
                        <svg width="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M8.75 2.625H2.625V8.75H8.75V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.375 2.625H12.25V8.75H18.375V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.375 12.25H12.25V18.375H18.375V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.75 12.25H2.625V18.375H8.75V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        { (isSideBarExpanded && !isMobile) &&
                        <span className='buttonText'>
                            Projects
                        </span>
                        }
                    </button>
                </NavLink>
                }
                { ['admin', 'manager'].includes(user.userType) &&
                <NavLink to='/applications' className='navLink'>
                    <button id='applications'>
                        <svg width="21" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <rect x="1.47275" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 1.47275 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                            <rect x="8.57383" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 8.57383 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                        </svg>
                        { (isSideBarExpanded && !isMobile) &&
                        <span className='buttonText'>
                            Applications
                        </span>
                        }
                    </button>
                </NavLink>
                }
                { ['admin', 'manager'].includes(user.userType) &&
                <NavLink to='/users' className='navLink'>
                    <button id='users'>
                        <svg width="21" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M13.0007 16.4388C17.7008 16.4388 21.6673 17.2025 21.6673 20.1492C21.6673 23.097 17.6748 23.8337 13.0007 23.8337C8.30156 23.8337 4.33398 23.0699 4.33398 20.1232C4.33398 17.1754 8.32648 16.4388 13.0007 16.4388ZM13.0007 2.16699C16.1847 2.16699 18.7358 4.71718 18.7358 7.89897C18.7358 11.0807 16.1847 13.632 13.0007 13.632C9.81771 13.632 7.2655 11.0807 7.2655 7.89897C7.2655 4.71718 9.81771 2.16699 13.0007 2.16699Z" fill="currentColor"/>
                        </svg>
                        { (isSideBarExpanded && !isMobile) &&
                        <span className='buttonText'>
                            Users
                        </span>
                        }
                    </button>
                </NavLink>
                }
            </div>
            
        </div>
        <div className={`bottomSection ${!isSideBarExpanded ? 'collapsed':''} ${isMobile ? 'mobile':''}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
              <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
            </svg>
            { (isSideBarExpanded && !isMobile) &&
            <div className='details'>
                <div>
                    <div>
                        {`${capitalizeFirstLetter(user.firstName)} ${capitalizeFirstLetter(user.lastName)}`}
                    </div>
                    <div className='email'>
                        {user.email}
                    </div>
                </div>
                <svg className='logout' onClick={handleLogOut} width="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.33333 14H2.44444C2.06135 14 1.69395 13.8478 1.42307 13.5769C1.15218 13.306 1 12.9386 1 12.5556V2.44444C1 2.06135 1.15218 1.69395 1.42307 1.42307C1.69395 1.15218 2.06135 1 2.44444 1H5.33333M10.3889 11.1111L14 7.5M14 7.5L10.3889 3.88889M14 7.5H5.33333" stroke="#F83D34" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            }
        </div>
    </div>
  )
}
